module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av293-b58ec5bf97512ba9557f7d060428cbf7.jpg";